var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 20c0 8.837-7.163 16-16 16S4 28.837 4 20 11.163 4 20 4s16 7.163 16 16zm-17.85 8.472L30.02 16.6a1.032 1.032 0 000-1.46l-1.46-1.46a1.032 1.032 0 00-1.46 0l-9.68 9.682-4.52-4.52a1.032 1.032 0 00-1.46 0l-1.46 1.46a1.032 1.032 0 000 1.46l6.71 6.709a1.032 1.032 0 001.46 0z"
  })));
}
export default SvgCheckmarkFill;